import { UserAccountState } from './state';
import { MutationTree } from 'vuex';
import { GetProfileUserAccountsInfo } from '@/store/graphql/queries/westerosArcaneumQueries';

const mutations: MutationTree<UserAccountState> = {
  SET_EMAIL_TOKEND(state, email: string) {
    state.email = email;
  },

  SET_PROFILE_USER_INFO(state, profile: GetProfileUserAccountsInfo) {
    const { firstName, lastName, phoneCountryCode, phoneRegionCode, phoneNumber } = profile;
    const phone = phoneCountryCode + phoneRegionCode + phoneNumber;

    state.firstName = firstName;
    state.lastName = lastName;
    state.phoneNumber = phone;
  },

  SET_STUDENT_EMAIL_HAS_ACCOUNTS(state, hasAccounts: boolean) {
    state.studentEmailHasAccounts = hasAccounts;
  },
};

export default mutations;
